import { CoverageChange, SelfEnrollType } from '@zorro/clients';
import { useMonolithQuery } from '@zorro/web/ui-utils';

import { MajorMedicalPlanCardProps } from './MajorMedicalPlanCard';

type Props = {
  onboardingPeriodId?: string;
};

export const useMajorMedicalPlanCardQuery = ({
  onboardingPeriodId,
}: Props): MajorMedicalPlanCardProps => {
  const { data: benefits, isLoading: isLoadingBenefits } = useMonolithQuery({
    method: 'benefitsControllerGetBenefits',
    params: onboardingPeriodId && [onboardingPeriodId],
  });

  const { data: onboardingPeriodStatuses, isLoading: isLoadingStatuses } =
    useMonolithQuery({
      method: 'enrollmentReportsControllerFetchSingleOnboardingPeriodStatuses',
      params: onboardingPeriodId && [onboardingPeriodId],
    });

  const plan = benefits?.majorMedicalBenefit?.plan;

  return {
    name: plan?.name ?? undefined,
    carrierName: plan?.carrierName,
    externalID: plan?.externalID ?? undefined,
    planMarket: plan?.planMarket ?? undefined,
    benefitsSummaryUrl: plan?.benefitsSummaryUrl ?? undefined,
    shouldShowRenewalTag:
      onboardingPeriodStatuses?.coverageChange === CoverageChange.RENEWAL,
    shouldShowSelfEnrollTag: plan?.selfEnroll === SelfEnrollType.SELF_ENROLL,
    policyType: plan?.policyType ?? undefined,
    isLoading: isLoadingBenefits || isLoadingStatuses,
    onboardingPeriodId,
  };
};
